import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1eaa4a76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "menu-content" }
const _hoisted_3 = { class: "copyright" }

import LanguagePicker from "./languagePicker.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'rightSliderMenu',
  props: {
  isMenuOpen: { type: Boolean, default: true },
},
  emits: ["close"],
  setup(__props, { emit }) {




const emitCloseMenu = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`right-slider-menu ${__props.isMenuOpen ? 'expand' : ''}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "cross_icon",
        src: "/img/cross-x_icon.svg",
        alt: "cross",
        onClick: emitCloseMenu
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(LanguagePicker, {
          "is-mobile": false,
          class: "language-picker menu-content-item"
        }),
        _createVNode(LanguagePicker, {
          "is-mobile": true,
          class: "language-picker-mobile menu-content-item"
        })
      ]),
      _createElementVNode("span", _hoisted_3, "© CyberSystem " + _toDisplayString(new Date().getFullYear()), 1)
    ])
  ], 2))
}
}

})